/**
 * UISeatmap
 *
 * Options:
 *      onSeatSelected(data, that):                         function - Callback, called when seat was selected.
 *      onSeatReset(data, that):                            function - Callback, called when seat was reset.
 *      beforeSeatSelected(segment_id, passenger_id, that): function - Callback, called before passenger's selection was handled.
 *      navigatePrev($seatmap, $seatmaps_wrapper, that):    function - Callback, called when "Back" navigation button was pressed.
 *      navigateNext($seatmap, $seatmaps_wrapper, that):    function - Callback, called when "Forward" navigation button was pressed.
 */
var UISeatmap = (function ($) {

    UISeatmap = function (options) {
        var that = this;

        that.$seatmap = options['$wrapper'] || null;
        that.$seats_description = options['$seats_description'] || $.sa.$document.find(that.selectors.seats_description);

        if (that.$seatmap && that.$seatmap.length) {
            // DOM
            that.$seatmaps_wrapper = that.$seatmap.parents(that.selectors.seatmaps_wrapper);
            that.$seatmap_head_selected_seats = that.$seatmap.find(that.selectors.seatmap_head_selected_seats);
            that.$seatmap_navigation_prev = that.$seatmap.find(that.selectors.seatmap_navigation_prev);
            that.$seatmap_navigation_next = that.$seatmap.find(that.selectors.seatmap_navigation_next);
            that.$chairs = that.$seatmap.find(that.selectors.chair);

            // CONST
            that.locales = Object.assign({}, {
                places: '',
                places_not_selected: '',
                tooltip_not_for_infant: '',
                tooltip_not_for_infant_and_children: '',
                tooltip_not_for_unaccompanied_child: ''
            }, options['locales']);
            that.modals = options['modals'];
            that.segment_id = options['segment_id'] || that.getSegmentId();

            that.SEATS_PROPS = {
                'not_for_infant': 'not_for_infant',
                'not_for_unaccompanied_child': 'not_for_unaccompanied_child',
                'emergency_exit': 'additional_exit', // currently working not correctly
                'bulkhead': 'bulkhead', // currently not supported
                'last_offer': 'last_offer'
            };

            that.PASSENGER_CATEGORIES = {
                infants: ['INF', 'INS', 'API', 'APS', 'CNF', 'ENF', 'ENS', 'FBI', 'FGI', 'FIP', 'FIS', 'FNF', 'FSP', 'GIF', 'GIS', 'ICF', 'INR', 'INX', 'INY', 'ISR', 'ITF', 'ITS', 'JNF', 'JNS', 'LIF', 'LNS', 'MEI', 'MIF', 'MNF', 'MNS', 'MSS', 'NBI', 'NBS', 'PEI', 'PES', 'SEF', 'SES', 'SNF', 'SNS', 'TIF', 'TNF', 'VFF', 'ZEI'],
                children: ['CHD', 'CNN'],//TODO: other children categories - ?
                unaccompanied_child: ['UNN', 'UNR', 'FCP', 'FCU', 'LUN', 'NBU', 'SUC']
            };

            that.SEATMAP_HIDING_ANIMATION_DURATION = 500;
            that.SEATMAP_SHOWING_ANIMATION_DURATION = 1000;

            // DYNAMIC VARS
            that.current_passenger = {};

            // HANDLERS
            that.onSeatSelected = (options['onSeatSelected'] || function () {});
            that.onSeatReset = (options['onSeatReset'] || function () {});
            that.beforeSeatSelected = (options['beforeSeatSelected'] || function () {});
            that.navigatePrev = (options['navigatePrev'] || function () {});
            that.navigateNext = (options['navigateNext'] || function () {});

            // INIT
            that.init(options);
        }
    };

    UISeatmap.prototype.class = {
        seatmap_current: 'current',
        seatmap_hidden: 'hidden',
        seatmap_animation: 'animation',
        seatmap_navigation_disabled: 'disabled',

        seats_description_seat_row_no_border: 'no-border',

        chair_selected: 'selected',
        chair_occupied: 'occupied',
        chair_comfort: 'js-seat-comfort',
        chair_not_available: 'not-available',

        seatmap_head_selected_seat_names: 'js-seat-names',
    };

    UISeatmap.prototype.selectors = {
        seatmaps_wrapper: '.js-seatmaps-wrapper',
        seatmap_head_selected_seats: '.js-seatmap-head-selected-seats',
        seatmap_cabins: '.js-seatmap-cabins',
        seatmap_navigation_prev: '.js-seatmap-prev',
        seatmap_navigation_next: '.js-seatmap-next',

        seats_description: '.js-seats-description',
        seats_description_seat_row: '.js-seat-price-row',

        row: '.js-seatmap-row',

        chair: '.js-seatmap-chair',
        chair_price: '.js-seatmap-chair-price',
        chair_tooltip_state_text: '.js-seatmap-chair-tooltip-state',
        chair_tooltip_for_passenger: '.js-seatmap-chair-tooltip-passenger',
        chair_passenger_name: '.js-seatmap-chair-passenger-name',
        chair_comfort_icon: '.js-seatmap-chair-comfort-icon',
        chair_disabled_icon: '.js-seatmap-chair-disabled-icon',
    };

    UISeatmap.prototype.data_keys = {
        seatmap_segment_id: 'segment-id',

        row_number: 'number',

        chair_name: 'name',
        chair_unavailable: 'unavailable',
        chair_airline_svc_id: 'airline-svc',
        chair_passenger_id: 'passenger-id',
        chair_passenger_data: 'passenger-data',
        chair_price: 'price',
        chair_currency: 'currency',

        chair_price_passenger_id: 'passenger-id',
        chair_price_value: 'value',
        chair_price_currency: 'currency',

        chair_prop_part: 'prop',
    };

    UISeatmap.prototype.init = function (options) {
        var that = this;

        if (options.hasOwnProperty('passenger_id') && options.hasOwnProperty('passenger_data')) {
            that.changePassenger(options.passenger_id, options.passenger_data);
        }

        that.initEventHandlers();

        that.setInitialSeatsSelected(options);
    };

    UISeatmap.prototype.initEventHandlers = function () {
        var that = this;

        that.$chairs.on('click', function (e) {
            var $chair = $(this),
                $row = that.getChairRow($chair),
                row_number = that.getRowNumber($row),
                chair_name = that.getChairName($chair);

            if (that.isChairAvailable($chair) && !that.isChairSelected($chair)) {

                if (row_number === 1) {
                    that.__showWarningDialog(
                        $chair,
                        that.modals.warning_first_row.title,
                        that.modals.warning_first_row.content,
                        that.modals.warning_first_row.button_confirm_text,
                        that.modals.warning_first_row.button_cancel_text,
                        'seatmap-warning-bulkhead-seat'
                    );
                } else if (that.isChairHasProperty($chair, that.SEATS_PROPS.bulkhead)) {
                    that.__showWarningDialog(
                        $chair,
                        that.modals.warning_bulkhead_seat.title,
                        that.modals.warning_bulkhead_seat.content,
                        that.modals.warning_bulkhead_seat.button_confirm_text,
                        that.modals.warning_bulkhead_seat.button_cancel_text,
                        'seatmap-warning-bulkhead-seat'
                    );
                } else if (that.isChairHasProperty($chair, that.SEATS_PROPS.emergency_exit)) {
                    that.__showWarningDialog(
                        $chair,
                        that.modals.warning_emergency_exit_seat.title,
                        that.modals.warning_emergency_exit_seat.content,
                        that.modals.warning_emergency_exit_seat.button_confirm_text,
                        that.modals.warning_emergency_exit_seat.button_cancel_text,
                        'seatmap-warning-emergency-exit-seat'
                    );
                } else {
                    that.select($chair);
                }
            }
            // reset selected chair on click (see https://tracker.flysa.ru/browse/SMA-2573)
            else if (that.isChairSelected($chair)) {
                var chair_passenger_data = that.getChairPassengerData($chair),
                    chair_passenger_id = that.getChairPassengerId($chair);
                // firstly set passenger who owns that seat as current
                that.changePassenger(chair_passenger_id, chair_passenger_data);
                // then reset seat
                that.reset(chair_name);
            }
        });

        that.$seatmap_navigation_prev.on('click', function (e) {
            if (!$(this).hasClass(that.class.seatmap_navigation_disabled)) {
                that.navigatePrev(that.$seatmap, that.$seatmaps_wrapper, that);
            }
        });

        that.$seatmap_navigation_next.on('click', function (e) {
            if (!$(this).hasClass(that.class.seatmap_navigation_disabled)) {
                that.navigateNext(that.$seatmap, that.$seatmaps_wrapper, that);
            }
        });
    };

    UISeatmap.prototype.setInitialSeatsSelected = function (options) {
        var that = this,
            seats_paid = options['selected_seats_paid'] || [],
            seats_unpaid = options['selected_seats_unpaid'] || [];

        var apply = function (selection_data, is_paid) {
            if (
                that.isThatSegment(selection_data.segment_id) &&
                selection_data.item_quantity > 0
            ) {

                var $chair = that.getChairByName(selection_data.item_text),
                    passenger = Object.assign({id: selection_data.passenger_id}, selection_data.passenger_data);

                // set proper price to seat
                that.__setPassengerChairPrice($chair, selection_data.passenger_id);

                that.select($chair, true, is_paid, passenger);
            }
        };

        seats_unpaid.forEach(function (seat_selection_data) {
            apply(seat_selection_data, false);
        });

        seats_paid.forEach(function (seat_selection_data) {
            apply(seat_selection_data, true);
        });
    };

    UISeatmap.prototype.isThatSegment = function (segment_id) {
        if (!this.segment_id || !segment_id) {
            return false;
        }
        return this.segment_id.toString() === segment_id.toString();
    };

    UISeatmap.prototype.toggleSeatmap = function (current_segment_id) {
        var that = this;

        // if seatmap is related to current segment - set it current
        if (that.isThatSegment(current_segment_id)) {
            if (!that.isSeatmapCurrent()) {
                that.setSeatmapCurrent();
            }
        }
        // otherwise - unset it current
        else {
            that.unsetSeatmapCurrent();
        }
    };

    UISeatmap.prototype.select = function ($chair, forced = false, is_paid = false, passenger = null) {
        var that = this,
            passenger_data;

        if (null === passenger) {
            passenger = that.current_passenger;
        }

        passenger_data = Object.assign({}, passenger);
        delete passenger_data.id;

        if (
            !forced &&
            (!that.isChairAvailable($chair) || that.isChairSelected($chair))
        ) {
            return;
        }

        that.beforeSeatSelected(that.segment_id, passenger.id, that);

        that.setChairSelected($chair, passenger);

        var chair_name = that.getChairName($chair),
            chair_airline_svc_id = that.getChairAirlineSvcId($chair),
            chair_price = that.getChairPrice($chair),
            chair_currency = that.getChairCurrency($chair);

        that.displaySelectedSeatInList(chair_name);

        that.onSeatSelected({
            segment_id: that.segment_id,
            passenger_id: passenger.id,
            item_id: chair_airline_svc_id,
            item_text: chair_name,
            item_quantity: 1,
            item_quantity_diff: 1,
            item_price: chair_price,
            currency: chair_currency,
            is_paid: is_paid,
            passenger_data: passenger_data
        }, that);
    };

    UISeatmap.prototype.reset = function (chair_name, call_callback = true) {
        var that = this,
            $chair = that.getChairByName(chair_name);

        that.setChairUnselected($chair);
        that.removeSelectedSeatFromList(chair_name);

        if (call_callback) {
            var chair_airline_svc_id = that.getChairAirlineSvcId($chair),
                chair_price = that.getChairPrice($chair),
                chair_currency = that.getChairCurrency($chair);

            that.onSeatReset({
                segment_id: that.segment_id,
                passenger_id: that.current_passenger.id,
                item_id: chair_airline_svc_id,
                item_text: chair_name,
                item_quantity: 0,
                item_quantity_diff: -1,
                item_price: chair_price,
                currency: chair_currency
            }, that);
        }
    };

    UISeatmap.prototype.changePassenger = function (passenger_id_new, passenger_data_new) {
        var that = this;

        // change seatmap for new passenger
        that.$chairs.each(function () {
            var $chair = $(this);

            // display proper price and set it to seats
            that.__setPassengerChairPrice($chair, passenger_id_new);

            // set seats available/unavailable depending on seat props and passenger props
            that.__toggleChairByPassengerCategory($chair, passenger_id_new, passenger_data_new.category_code, passenger_data_new.host_child_id);
        });

        // change seats description for new current passenger
        that.__showPassengerSeatsDescription(passenger_id_new);

        that.__savePassengerData(passenger_id_new, passenger_data_new);
    };

    UISeatmap.prototype.__setPassengerChairPrice = function ($chair, passenger_id) {
        var that = this,
            $chair_price = $chair.find(that.selectors.chair_price),
            $chair_price_for_passenger =  $chair_price.filter('[data-' + that.data_keys.chair_price_passenger_id + '=' + passenger_id + ']'),
            chair_price_value = $chair_price_for_passenger.data(that.data_keys.chair_price_value) || 0,
            chair_price_currency = $chair_price_for_passenger.data(that.data_keys.chair_price_currency) || '';

        if (that.isChairAvailable($chair)) {
            // show price for specified passenger
            $chair_price_for_passenger.show();
            // hide other prices
            $chair_price_for_passenger.siblings(that.selectors.chair_price).hide();
        } else {
            $chair_price.hide();
        }
        // set price data-attribute to chair
        that.setChairPrice($chair, chair_price_value);
        // set currency data-attribute to chair
        that.setChairCurrency($chair, chair_price_currency);
    };

    UISeatmap.prototype.__showPassengerSeatsDescription = function (passenger_id) {
        var that = this,
            $seats_description_rows_all = that.$seats_description.find(that.selectors.seats_description_seat_row),
            $seats_description_seat_row_for_passenger = $seats_description_rows_all.filter('[data-passenger-id=' + passenger_id + '][data-segment-id=' + that.segment_id + ']');

        $seats_description_rows_all.hide();
        if ($seats_description_seat_row_for_passenger.length) {
            $seats_description_seat_row_for_passenger.first().addClass(that.class.seats_description_seat_row_no_border);
            $seats_description_seat_row_for_passenger.show();
        }
    };

    UISeatmap.prototype.__toggleChairByPassengerCategory = function ($chair, passenger_id, passenger_category_code, passenger_host_child_id = null) {
        var that = this,
            $chair_price = $chair.find(that.selectors.chair_price),
            $chair_price_for_passenger =  $chair_price.filter('[data-' + that.data_keys.chair_price_passenger_id + '=' + passenger_id + ']');

        if (that.isChairSelected($chair)) {
            return;
        }

        // if passenger belongs to category which is restricted to occupy this seat - make seat unavailable
        if (
            (
                // not for unaccompanied child
                (
                    that.isChairHasProperty($chair, that.SEATS_PROPS.not_for_unaccompanied_child) &&
                    that.isPassengerInCategoryGroup(passenger_category_code, 'unaccompanied_child')
                ) ||
                // not for infants
                (
                    that.isChairHasProperty($chair, that.SEATS_PROPS.not_for_infant) &&
                    // if passenger is infant or passenger accompanying the infant
                    (
                        that.isPassengerInCategoryGroup(passenger_category_code, 'infants') ||
                        passenger_host_child_id // only infants without seat are specified by Sirena in `host_child_id`
                    )
                ) ||
                // emergency exit
                (
                    that.isChairHasProperty($chair, that.SEATS_PROPS.emergency_exit) &&
                    (
                        that.isPassengerInCategoryGroup(passenger_category_code, 'infants') ||
                        that.isPassengerInCategoryGroup(passenger_category_code, 'children') ||
                        passenger_host_child_id // only infants without seat are specified by Sirena in `host_child_id`
                    )
                )
            ) &&
            !that.isChairUnavailablePermanently($chair)
        ) {
            that.setChairUnavailable($chair);

            // set tooltip with content depending on passenger
            var tooltip_passenger_text = '';
            if (that.isChairHasProperty($chair, that.SEATS_PROPS.not_for_unaccompanied_child)) {
                tooltip_passenger_text = that.locales.tooltip_not_for_unaccompanied_child;
            }
            if (that.isChairHasProperty($chair, that.SEATS_PROPS.not_for_infant)) {
                tooltip_passenger_text = that.locales.tooltip_not_for_infant;
            }
            if (
                that.isChairHasProperty($chair, that.SEATS_PROPS.emergency_exit) &&
                (
                    that.isPassengerInCategoryGroup(passenger_category_code, 'infants') ||
                    that.isPassengerInCategoryGroup(passenger_category_code, 'children') ||
                    passenger_host_child_id // only infants without seat are specified by Sirena in `host_child_id`
                )
            ) {
                tooltip_passenger_text = that.locales.tooltip_not_for_infant_and_children;
            }
            that.setChairTooltipForPassenger($chair, tooltip_passenger_text);

            $chair_price.hide();
        }
        // otherwise, if seat is currently, but not permanently, unavaliable - make it available
        else if (that.isChairUnavailableDynamically($chair) && !that.isChairUnavailablePermanently($chair)) {
            that.setChairAvailable($chair);
            that.setChairTooltipForPassenger($chair, '');
            $chair_price_for_passenger.show();
        }
        // in any other cases - just drop tooltip
        else {
            that.setChairTooltipForPassenger($chair, '');
        }
    };

    UISeatmap.prototype.__savePassengerData = function (passenger_id_new, passenger_data_new = {}) {
        var that = this;
        that.current_passenger = Object.assign({id: passenger_id_new}, passenger_data_new);
    };

    UISeatmap.prototype.isCurrentPassenger = function (passenger_id) {
        if (!this.current_passenger || !this.current_passenger.id || !passenger_id) {
            return false;
        }
        return this.current_passenger.id.toString() === passenger_id.toString();
    };


    UISeatmap.prototype.setSeatmapCurrent = function () {
        var that = this;

        that.$seatmap.addClass(that.class.seatmap_current);
        setTimeout(function () { // delay on seatmap hiding animation duration
            that.$seatmap.removeClass(that.class.seatmap_hidden);
            that.__animateSeatmapCabins(true);
        }, that.SEATMAP_HIDING_ANIMATION_DURATION);
    };

    UISeatmap.prototype.unsetSeatmapCurrent = function () {
        var that = this;

        that.$seatmap.removeClass(that.class.seatmap_current);
        that.__animateSeatmapCabins(false);
        setTimeout(function () { // wait for hiding animation ends
            that.$seatmap.addClass(that.class.seatmap_hidden);
        }, that.SEATMAP_HIDING_ANIMATION_DURATION);
    };

    UISeatmap.prototype.isSeatmapCurrent = function () {
        var that = this;
        return that.$seatmap.hasClass(that.class.seatmap_current);
    };

    UISeatmap.prototype.setChairSelected = function ($chair, passenger = null) {
        var that = this,
            $chair_passenger_name = $chair.find(that.selectors.chair_passenger_name),
            $chair_comfort_icon = $chair.find(that.selectors.chair_comfort_icon);

        if (null === passenger) {
            passenger = that.current_passenger;
        }

        $chair.addClass(that.class.chair_selected);

        var passenger_id = passenger.id,
            passenger_data = Object.assign({}, passenger);
        delete passenger_data.id;

        that.setChairPassengerId($chair, passenger_id);
        that.setChairPassengerData($chair, passenger_data);

        $chair_passenger_name.text(passenger.literals);
        $chair_passenger_name.show();

        $chair_comfort_icon.hide();
    };

    UISeatmap.prototype.setChairUnselected = function ($chair) {
        var that = this,
            $chair_passenger_name = $chair.find(that.selectors.chair_passenger_name),
            $chair_comfort_icon = $chair.find(that.selectors.chair_comfort_icon);

        $chair.removeClass(that.class.chair_selected);

        that.unsetChairPassengerId($chair);
        that.unsetChairPassengerData($chair);

        $chair_passenger_name.text('');
        $chair_passenger_name.hide();

        if (that.isChairComfort($chair)) {
            $chair_comfort_icon.show();
        }
    };

    UISeatmap.prototype.setChairUnavailable = function ($chair) {
        var that = this,
            $chair_passenger_name = $chair.find(that.selectors.chair_passenger_name),
            $chair_disabled_icon = $chair.find(that.selectors.chair_disabled_icon),
            $chair_comfort_icon = $chair.find(that.selectors.chair_comfort_icon);

        $chair.addClass(that.class.chair_not_available);

        that.unsetChairPassengerId($chair);
        that.unsetChairPassengerData($chair);

        $chair_passenger_name.text('');
        $chair_passenger_name.hide();

        $chair_disabled_icon.show();
        $chair_comfort_icon.hide();
    };

    UISeatmap.prototype.setChairAvailable = function ($chair) {
        var that = this,
            $chair_passenger_name = $chair.find(that.selectors.chair_passenger_name),
            $chair_disabled_icon = $chair.find(that.selectors.chair_disabled_icon),
            $chair_comfort_icon = $chair.find(that.selectors.chair_comfort_icon),
            passenger_literals = that.current_passenger.literals || '';

        $chair.removeClass(that.class.chair_not_available);

        $chair_disabled_icon.hide();

        if (that.isChairSelected($chair)) {
            $chair_passenger_name.text(passenger_literals);
            $chair_passenger_name.show();
        }

        if (that.isChairComfort($chair)) {
            if (!that.isChairSelected($chair)) {
                $chair_comfort_icon.show();
            } else {
                $chair_comfort_icon.hide();
            }
        }
    };

    UISeatmap.prototype.setChairTooltipForPassenger = function ($chair, tooltip) {
        var that = this,
            $tooltip_for_passenger = $chair.find(that.selectors.chair_tooltip_for_passenger);
        $tooltip_for_passenger.text(tooltip);
    };

    UISeatmap.prototype.displaySelectedSeatInList = function (seat_name) {
        var that = this,
            $seat_names = that.$seatmap_head_selected_seats.find('.' + that.class.seatmap_head_selected_seat_names),
            seat_names_str = $seat_names.length ? $seat_names.text() : '';

        if (seat_names_str.length) {
            seat_names_str += ', ';
        }
        seat_names_str += seat_name;

        if (!$seat_names.length) {
            that.$seatmap_head_selected_seats.html(that.locales.places ? that.locales.places + ': ' : '');

            $seat_names = $('<span/>').addClass(that.class.seatmap_head_selected_seat_names);
            $seat_names.text(seat_names_str);
            that.$seatmap_head_selected_seats.append($seat_names);
        } else {
            $seat_names.text(seat_names_str);
        }
    };

    UISeatmap.prototype.removeSelectedSeatFromList = function (seat_name) {
        var that = this,
            $seat_names = that.$seatmap_head_selected_seats.find('.' + that.class.seatmap_head_selected_seat_names),
            seat_names_all = $seat_names.length ? $seat_names.text() : '';

        if (!seat_names_all.length || !seat_names_all.includes(seat_name)) {
            return;
        }

        var seat_names_all_arr = seat_names_all.split(', '),
            seat_name_index = seat_names_all_arr.indexOf(seat_name);
        seat_names_all_arr.splice(seat_name_index, 1);

        if (!seat_names_all_arr.length) {
            that.$seatmap_head_selected_seats.html(that.locales.places_not_selected ? that.locales.places_not_selected : '');
        } else {
            $seat_names.text(seat_names_all_arr.join(', '));
        }
    };


    UISeatmap.prototype.isChairAvailable = function ($chair) {
        return !this.isChairUnavailablePermanently($chair) &&
            !this.isChairUnavailableDynamically($chair) &&
            !this.isChairOccupied($chair);
    };

    UISeatmap.prototype.isChairSelected = function ($chair) {
        return $chair.hasClass(this.class.chair_selected);
    };

    UISeatmap.prototype.isChairOccupied = function ($chair) {
        return $chair.hasClass(this.class.chair_occupied);
    };

    UISeatmap.prototype.isChairComfort = function ($chair) {
        return $chair.hasClass(this.class.chair_comfort);
    };

    UISeatmap.prototype.isChairUnavailablePermanently = function ($chair) {
        return !!$chair.data(this.data_keys.chair_unavailable);
    };

    UISeatmap.prototype.isChairUnavailableDynamically = function ($chair) {
        return $chair.hasClass(this.class.chair_not_available);
    };


    UISeatmap.prototype.getChairPropertyValue = function ($chair, property) {
        var that = this;
        return $chair.data(that.data_keys.chair_prop_part + '-' + property);
    };

    UISeatmap.prototype.isChairHasProperty = function ($chair, property) {
        var that = this;
        return !!that.getChairPropertyValue($chair, property);
    };

    UISeatmap.prototype.isPassengerInCategoryGroup = function (passenger_category_code, category_group_name) {
        var that = this;

        if (!that.PASSENGER_CATEGORIES.hasOwnProperty(category_group_name) || !passenger_category_code) {
            return false;
        }

        var category_group = that.PASSENGER_CATEGORIES[category_group_name];

        if (!Array.isArray(category_group)) {
            return category_group === passenger_category_code;
        } else {
            return category_group.includes(passenger_category_code);
        }
    };


    UISeatmap.prototype.getChairRow = function ($chair) {
        return $chair.parents(this.selectors.row);
    };


    UISeatmap.prototype.getSegmentId = function () {
        return this.$seatmap.data(this.data_keys.seatmap_segment_id);
    };

    UISeatmap.prototype.getRowNumber = function ($row) {
        return parseInt($row.data(this.data_keys.row_number), 10);
    };

    UISeatmap.prototype.getChairName = function ($chair) {
        return $chair.data(this.data_keys.chair_name);
    };

    UISeatmap.prototype.getChairAirlineSvcId = function ($chair) {
        return $chair.data(this.data_keys.chair_airline_svc_id);
    };

    UISeatmap.prototype.getChairPrice = function ($chair) {
        return parseFloat($chair.data(this.data_keys.chair_price));
    };

    UISeatmap.prototype.setChairPrice = function ($chair, price) {
        $chair.data(this.data_keys.chair_price, parseFloat(price));
    };

    UISeatmap.prototype.getChairCurrency = function ($chair) {
        return $chair.data(this.data_keys.chair_currency);
    };

    UISeatmap.prototype.setChairCurrency = function ($chair, currency) {
        $chair.data(this.data_keys.chair_currency, currency);
    };

    UISeatmap.prototype.setChairPassengerId = function ($chair, passenger_id) {
        var that = this;
        // use `attr` because `data` would be ignored when cloning
        $chair.attr('data-' + that.data_keys.chair_passenger_id, passenger_id);
    };

    UISeatmap.prototype.getChairPassengerId = function ($chair) {
        var that = this;
        return $chair.attr('data-' + that.data_keys.chair_passenger_id);
    };

    UISeatmap.prototype.unsetChairPassengerId = function ($chair) {
        var that = this;
        // use `attr` because `data` would be ignored when cloning
        $chair.attr('data-' + that.data_keys.chair_passenger_id, '');
    };

    UISeatmap.prototype.setChairPassengerData = function ($chair, passenger_data) {
        var that = this;
        // use `attr` because `data` would be ignored when cloning
        $chair.attr('data-' + that.data_keys.chair_passenger_data, JSON.stringify(passenger_data));
    };

    UISeatmap.prototype.getChairPassengerData = function ($chair) {
        var that = this,
            passenger_data = $chair.attr('data-' + that.data_keys.chair_passenger_data);
        if (!passenger_data) {
            return null;
        }
        return JSON.parse(passenger_data);
    };

    UISeatmap.prototype.unsetChairPassengerData = function ($chair) {
        var that = this;
        // use `attr` because `data` would be ignored when cloning
        $chair.attr('data-' + that.data_keys.chair_passenger_data, '');
    };


    UISeatmap.prototype.getChairByName = function (chair_name) {
        var that = this;
        return that.$chairs.filter('[data-' + that.data_keys.chair_name + '=' + chair_name + ']');
    };

    /**
     * @param {Boolean} state `true` if show, `false` if hide
     * @private
     */
    UISeatmap.prototype.__animateSeatmapCabins = function (state) {
        var that = this,
            $seatmap_cabins = that.$seatmap.find(that.selectors.seatmap_cabins),
            animation_class,
            animation_timeout;

        if (state) {
            animation_class = 'fadeIn';
            animation_timeout = that.SEATMAP_SHOWING_ANIMATION_DURATION;
        } else {
            animation_class = 'fadeOut faster';
            animation_timeout = that.SEATMAP_HIDING_ANIMATION_DURATION;
        }

        $seatmap_cabins.addClass(that.class.seatmap_animation)
            .addClass('animated')
            .addClass(animation_class);


        setTimeout(function () {
            // clear animation classes
            $seatmap_cabins.removeClass(that.class.seatmap_animation)
                .removeClass(animation_class)
                .removeClass('animated')
                .removeClass('faster');
        }, animation_timeout);
    };

    UISeatmap.prototype.__showWarningDialog = function (
        $chair,
        title,
        content,
        button_confirm_text,
        button_cancel_text,
        custom_class
    ) {
        var that = this;

        if ($.sa.is_desktop()) {
            $.uiModal({
                custom_class: custom_class,
                header_title: title || '',
                content: content || '',
                button_confirm_text: button_confirm_text || '',
                button_cancel_text: button_cancel_text || '',
                onButtonConfirmClick: function (modal, event) {
                    modal.close();
                    that.select($chair);
                }
            });
        } else {
            var $content_wrapper = $('<div/>').addClass('drawer-bottom-' + custom_class + '-content'),
                $footer_wrapper = $('<div/>').addClass('drawer-bottom-' + custom_class + '-footer'),
                $button_confirm = $('<button />').addClass('button').addClass('js-button-confirm').html(button_confirm_text),
                $button_cancel = $('<button />').addClass('button').addClass('ghost').addClass('js-button-cancel').html(button_cancel_text);

            $content_wrapper.append(content);

            $button_confirm.on('click', function (e) {
                var $drawer_bottom_wrapper = $(this).parents('.drawer-bottom'),
                    drawer_bottom = $drawer_bottom_wrapper.data('drawer_bottom');
                drawer_bottom.close();
                that.select($chair);
            });

            $button_cancel.on('click', function (e) {
                var $drawer_bottom_wrapper = $(this).parents('.drawer-bottom'),
                    drawer_bottom = $drawer_bottom_wrapper.data('drawer_bottom');
                drawer_bottom.close();
            });

            $footer_wrapper
                .append($button_confirm)
                .append($button_cancel);

            $.uiDrawerBottom({
                header: title || '',
                content: $content_wrapper,
                footer: $footer_wrapper,
                onOpen: function ($drawer_bottom_wrapper, event) {
                    $drawer_bottom_wrapper.addClass('drawer-bottom-' + custom_class);
                }
            });
        }
    };

    return UISeatmap;
})($);
